// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"621":"048b6939","743":"84e8476f","917":"21f27955"}[chunkId] + ".chunk.js";
};